import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { QualificationExportService } from '../../../service/qualification-export.service';

@Component({
  selector: 'wilson-qualification-export-dropdown',
  imports: [TranslatePipe, NzButtonModule, NzDropdownModule, NzTooltipModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @let hasQualificationReadPermission =
      can(RoleAction.Read, RolePermissionSubject.UserQualificationV2);
    <button
      nz-button
      nz-dropdown
      [nzDropdownMenu]="exportMenu"
      [nzPlacement]="'bottomLeft'"
      [disabled]="!hasQualificationReadPermission"
      [nzDisabled]="!hasQualificationReadPermission"
      nz-tooltip
      [nzTooltipTitle]="'general.no_permissions' | translate"
      [nzTooltipTrigger]="!hasQualificationReadPermission ? 'hover' : null"
    >
      {{ 'page.qualifications.export' | translate }}
    </button>
    <nz-dropdown-menu #exportMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item (click)="exportList()">
          {{ 'page.qualifications.export_modal.list' | translate }}
        </li>
        <li nz-menu-item (click)="exportWithCertificates()">
          {{
            'page.qualifications.export_modal.list_with_certificates'
              | translate
          }}
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
})
export class QualificationExportDropdownComponent {
  private exportService = inject(QualificationExportService);

  protected can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  exportList(): void {
    this.exportService.exportListModule();
  }

  exportWithCertificates(): void {
    this.exportService.exportQualificationForSingleUser();
  }
}
